// 🎉 Easter Eggs für Stadt-Suche mit Internationalisierung
export const getEasterEgg = (cityInput, lang = 'de') => {
  const input = cityInput.toLowerCase().trim();
  
  const easterEggs = {
    'atlantis': {
      de: '🌊 Leider keine Unterwasser-Toiletten verfügbar',
      en: '🌊 Unfortunately no underwater toilets available'
    },
    'hogwarts': {
      de: '🪄 Die Maulende Myrte lässt grüßen!',
      en: '🪄 Moaning Myrtle says hello!'
    },
    'narnia': {
      de: '🦁 Hinter dem Kleiderschrank nur schwer zu erreichen',
      en: '🦁 Hard to reach behind the wardrobe'
    },
    'mars': {
      de: '🚀 Noch keine interplanetaren WCs verfügbar',
      en: '🚀 No interplanetary restrooms available yet'
    },
    'mond': {
      de: '🌙 Apollo 11 hatte leider kein WC mit guter Bewertung',
      en: '🌙 Apollo 11 had no well-rated restroom'
    },
    'moon': {
      de: '🌙 Apollo 11 hatte leider kein WC mit guter Bewertung',
      en: '🌙 Apollo 11 had no well-rated restroom'
    },
    'sun': {
      de: '☀️ Heiße Empfehlung: Viel trinken und öfter mal eine Pause machen!',
      en: '☀️ Hot tip: Drink plenty and take breaks often!'
    },
    'sonne': {
      de: '☀️ Heiße Empfehlung: Viel trinken und öfter mal eine Pause machen!',
      en: '☀️ Hot tip: Drink plenty and take breaks often!'
    },
    'nordpol': {
      de: '🎅 Der Weihnachtsmann empfiehlt: Iglu mit Heizung!',
      en: '🎅 Santa recommends: Igloo with heating!'
    },
    'north pole': {
      de: '🎅 Der Weihnachtsmann empfiehlt: Iglu mit Heizung!',
      en: '🎅 Santa recommends: Igloo with heating!'
    },
    'überall': {
      de: '📍 Genau dafür gibt es diese App!',
      en: '📍 That\'s exactly what this app is for!'
    },
    'everywhere': {
      de: '📍 Genau dafür gibt es diese App!',
      en: '📍 That\'s exactly what this app is for!'
    },
    'zu hause': {
      de: '🏠 Da kennst du dich aber selbst aus, oder?',
      en: '🏠 You know your way around there yourself, right?'
    },
    'zuhause': {
      de: '🏠 Da kennst du dich aber selbst aus, oder?',
      en: '🏠 You know your way around there yourself, right?'
    },
    'home': {
      de: '🏠 Da kennst du dich aber selbst aus, oder?',
      en: '🏠 You know your way around there yourself, right?'
    },
    'at home': {
      de: '🏠 Da kennst du dich aber selbst aus, oder?',
      en: '🏠 You know your way around there yourself, right?'
    }
  };
  
  const easterEgg = easterEggs[input];
  if (!easterEgg) return null;
  
  // Rückgabe der passenden Übersetzung (Fallback auf Deutsch)
  return easterEgg[lang] || easterEgg['de'];
};